import { LocalJsonStorage } from "../../infra/http/local-json-storage";
import AuthPage from "../../presentation/screens/auth/AuthPage";

type Props = {};

export const AuthPageFactory = (props: Props) => {
  const storage = LocalJsonStorage.getInstance();
  return <AuthPage storage={storage} {...props} />;
};
